import * as types from '../const/action.types';

export function reportEmployeeIsLoading(state = false, action) {
    switch (action.type) {
        case types.REPORT_EMPLOYEE_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function report_employee(state = {}, action) {
    switch (action.type) {
        case types.REPORT_EMPLOYEE_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/api.reports.employee.reducer.js